import React, { useMemo } from 'react';
import { FaqContainerContentfulModel } from 'src/api/models/Faq';
import FAQList from 'app_previous/organisms/Shared/FAQList/FAQList';

export default function getDynamicFAQList(faqListProps: FaqContainerContentfulModel): React.ReactNode {
  const faqItems = useMemo(() => {
    return faqListProps.faqItems.map((faqItem) => ({
      question: faqItem.question.question,
      answer: faqItem.answer.raw,
    }));
  }, [faqListProps]);

  return (
    <div style={{ width: '100%', margin: '0 auto' }}>
      <FAQList faqItems={faqItems} />
    </div>
  );
}
